import { render, staticRenderFns } from "./entry-stacked.vue?vue&type=template&id=72ff5b04&scoped=true&"
import script from "./entry-stacked.vue?vue&type=script&lang=js&"
export * from "./entry-stacked.vue?vue&type=script&lang=js&"
import style0 from "./entry-stacked.vue?vue&type=style&index=0&id=72ff5b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff5b04",
  null
  
)

export default component.exports